import { WebhookEvents } from '~/api/types/webhookData.ts';

export enum ScalekitInternalEvents {
  AUTH_UPDATE = 'auth.update',
  IDP_AUTH_INITIATED = 'auth.idp_auth_initiated',
  ORG_USER_SIGNUP = 'auth.org_user_signup',
  IDP_INITIATE_SAML_BODY = 'auth.idp_initiate_saml_body'
}

export const DEVICE_DETAILS_AUTH_REQUEST_EVENT = 'auth.device_details';

export enum AuthRequestResponseEvents {
  SAML_REQUEST = 'auth.saml_request',
  SAML_RESPONSE = 'auth.saml_response',
  OIDC_REQUEST = 'auth.oidc_request',
  OIDC_RESPONSE = 'auth.oidc_response',
  OAUTH_REQUEST = 'auth.oauth_request',
  OAUTH_RESPONSE = 'auth.oauth_response'
}

export enum DirectoryEventTypes {
  DIR_USER_CREATED = WebhookEvents.DIR_USER_CREATED,
  DIR_USER_UPDATED = WebhookEvents.DIR_USER_UPDATED,
  DIR_USER_DELETED = WebhookEvents.DIR_USER_DELETED,
  DIR_GROUP_CREATED = WebhookEvents.DIR_GROUP_CREATED,
  DIR_GROUP_UPDATED = WebhookEvents.DIR_GROUP_UPDATED,
  DIR_GROUP_DELETED = WebhookEvents.DIR_GROUP_DELETED,
  DIR_DIR_CREATED = WebhookEvents.DIR_CREATED,
  DIR_DIR_ENABLED = WebhookEvents.DIR_ENABLED,
  DIR_DIR_DISABLED = WebhookEvents.DIR_DISABLED,
  DIR_DIR_DELETED = WebhookEvents.DIR_DELETED
}

export interface EventData {
  id: string;
  type: string;
  occurredAt: string;
  data: Record<any, any>;
  rawPayload?: string;
}

export interface EventsListResponse {
  prevPageToken: string;
  nextPageToken: string;
  totalSize: number;
  events: Array<EventData>;
}
